import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'mt-12 lg:mt-20',
    title:
      'text-brand-bioderma mb-6 text-[32px] leading-[1.3] font-medium max-lg:pl-4 lg:mb-10 lg:pl-0 lg:text-center lg:text-[40px]',
    tabs: 'scrollbar-hidden mb-6 flex gap-2 overflow-x-scroll overflow-y-visible px-4 lg:mb-11 lg:justify-center lg:px-0',
    tab: 'shadow-m flex min-w-max cursor-pointer items-center gap-5 rounded-[100px] border-2 p-[4px] pr-10 transition-colors',
    tabTitle:
      'text-brand-bioderma text-left text-[16px] leading-[1.4] font-bold',
    content: 'px-4 lg:px-0',
    text: 'text-brand-bioderma mx-auto mb-8 text-center text-[16px] leading-[1.7] max-lg:text-left lg:mb-15 lg:px-0 lg:text-[18px]',
    image: 'mx-auto h-auto w-full max-w-[400px]',
    imageLarge:
      'mx-auto h-auto w-full max-w-[1400px] overflow-hidden rounded-[20px] px-4 lg:rounded-[32px] lg:px-0',
    carousel:
      'flex justify-center [--slide-size:312px] [--slide-spacing:12px] lg:ml-5 lg:[--slide-size:412px]',
    carouselImage: 'overflow-hidden rounded-[20px] lg:rounded-[32px]',
    arrowPrev: 'absolute top-1/2 left-15 -translate-y-1/2',
    arrowNext: 'absolute top-1/2 right-15 -translate-y-1/2'
  },
  variants: {
    isActive: {
      false: {
        tab: 'landing-glass bg-white/25'
      },
      true: {
        tab: 'border-[#E0457B] bg-white'
      }
    },
    textWidth: {
      wide: { text: 'max-w-[1250px]' },
      narrow: { text: 'max-w-[1140px]' }
    }
  },
  defaultVariants: {
    isActive: false,
    textWidth: 'wide'
  }
});
